import React, { useEffect, useState } from 'react';
import { useThemeContext } from "./theme/ThemeContextProvider";
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { useGlobal } from './utils/GlobalContext';
import { CDNContent } from './services/cdn/CDNContent';
import Home from './areas/home/Home';
import About from './areas/about/About';
import Sessions from './areas/sessions/Sessions';
import Speakers from './areas/speakers/Speakers';
import PrivacyTerms from './areas/common/Privacy-Terms';
import CommunityGuidelines from './areas/common/CommunityGuidelines';
import CodeOfConduct from './areas/common/CodeOfConduct';
import Admin from './areas/admin/Admin';
import Account from './areas/account/Account';
import Header from './areas/common/Header';
import Footer from './areas/common/Footer';
import NoMatch from './areas/error/ErrorPage';
import { useMsal } from '@azure/msal-react';
import { Roles } from './utils/auth/auth';

export function App() {
    const { theme } = useThemeContext();
    const { instance } = useMsal();
    const {state, dispatch} = useGlobal();
    const [userRoles, setUserRoles] = useState<string[]>([]);
    const [hasRoles, setHasRoles] = useState(false);
    useEffect(()=>{
        if(state.UserProfile.RolesList.length>0 && hasRoles===false){
            setUserRoles(state.UserProfile.RolesList);
            setHasRoles(true);
        }
    });

    return (
        <>
            <CDNContent ></CDNContent>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Header/>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path="about" element={<About />} />
                        <Route path="sessions" element={<Sessions />} />
                        <Route path="speakers" element={<Speakers />} />
                        <Route path="privacy-terms" element={<PrivacyTerms />} />
                        <Route path="community-guidelines" element={<CommunityGuidelines />} />
                        <Route path="code-of-conduct" element={<CodeOfConduct />} />
                        <Route path="admin" element={Roles(["Admin"], userRoles)?<Admin />:<Navigate replace to={"/"} />} />
                        <Route path="account" element={Roles(["User"], userRoles)?<Account />:<Navigate replace to={"/"} />} />
                        <Route path="*" element={<NoMatch />} />
                    </Route>
                </Routes>
                <Footer/>
            </ThemeProvider>
        </>
    );
}

export default App;

function Layout() {
    return (
      <div>
            <Outlet />
      </div>
    );
  }